@if (analyseTypeSignal() === 'action' && isFinnet()) {
  <app-v2-analysis-header
    title="Unternehmensprofil"
    [updatedAt]="companyUpdatedAt()"
    [showBackButton]="showBackButton"
    (backClicked)="backClicked.emit()"
  ></app-v2-analysis-header>
}
<div class="body v2">
  @if (analyseTypeSignal() === 'action' && !isFinnet()) {
    <h2 class="v2-page-title">Unternehmensprofil</h2>
  }
  @if (loading()) {
    <app-paragraph-loader></app-paragraph-loader>
  } @else {
    @for (section of sections(); track section) {
      @if (section.title) {
        <h4>{{ section.title }}</h4>
      }
      @if (section.text) {
        <p [innerHTML]="formatText(section.text) | textClean"></p>
      }
    }
  }
</div>
